var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"transform":"matrix(9.6354 0 0 9.6354 -11.713 36.54)","strokeWidth":"1.2454","key":0},React.createElement("rect",{"x":"4.9842","y":"3.9842","width":"19.032","height":"11.016","ry":".77304","fill":"none","stroke":"#333","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.2454","style":{"paintOrder":"fill markers stroke"}})),React.createElement("path",{"d":"m38.499 77.094 90 52 89-52","fill":"none","stroke":"#333","strokeWidth":"12","key":1})]));
}

Mail.defaultProps = {"id":"SVGRoot","width":"256px","height":"256px","version":"1.1","viewBox":"0 0 256 256"};

module.exports = Mail;

Mail.default = Mail;
